import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'
import {
  hasAnyInvoiceSettingsAccess,
  hasInvoiceSettingAccess,
  type InvoiceSettingAccessKey,
} from '@/services/invoice/settingsAccess'

const moduleId = 19

export const canUserAccessModule = (user) => {
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && user.profile.modules.invoice?.isAccess
}

export const guardInvoiceAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const isEInvoicingSalesEnabled = () => {
  const userStore = useUserStore()
  return !!userStore.user?.firm?.options?.eInvoicing?.sales
}

export const isProjectEInvoicingEnabled = (project?: { eInvoicing?: boolean } | null) => {
  return isEInvoicingSalesEnabled() && !!project?.eInvoicing
}

export const guardEInvoicesAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  if (!canUserAccessModule(user))
    return { name: 'Home' }
  return isEInvoicingSalesEnabled() || { name: 'InvoiceList' }
}

export const guardInvoiceSettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  if (!canUserAccessModule(user))
    return { name: 'Home' }
  return hasAnyInvoiceSettingsAccess(user.profile.modules.invoice) || { name: 'Home' }
}

export const guardInvoiceSettingAccess = (key: InvoiceSettingAccessKey) => {
  const userStore = useUserStore()
  const user = userStore.user
  if (!canUserAccessModule(user))
    return { name: 'Home' }
  return hasInvoiceSettingAccess(user.profile.modules.invoice, key) || { name: 'Home' }
}

// export const guardTrainingCatalog = () => {
//   const userStore = useUserStore()
//   const user = userStore.user
//   return user.profile.modules.training?.catalogAccess ? user.profile.modules.training.catalogAccess : { name: 'Home' }
// }

// export const guardMyTraining = () => {
//   const userStore = useUserStore()
//   const user = userStore.user
//   return user.profile.modules.training?.myTrainingsAccess ? user.profile.modules.training.myTrainingsAccess : { name: 'Home' }
// }


export const canAccessInvoiceProjects = (project) => {
  const userStore = useUserStore()

  const projectAccess = userStore.user.profile.modules.project

  if (project.projectTarget !== 'client') {
    return false
  }

  if (!projectAccess.overviewOnlyPublic && projectAccess.onGlobalAccess.invoice) {
    return true
  } else if (projectAccess.onDirectorProject.isEnabled && projectAccess.onDirectorProject.invoice) {
    return project.directorId === userStore.user._id
  } else if (projectAccess.onManagerProject.isEnabled && projectAccess.onManagerProject.invoice) {
    return project.managerId === userStore.user._id
  } else if (projectAccess.onContributorProject.isEnabled && projectAccess.onContributorProject.invoice) {
    return project.contributorId === userStore.user._id
  } else {
    return false
  }
}
